import { useContext, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "./App.css";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Intro from "./components/intro/Intro";
import ProductList from "./components/productList/ProductList";
import Navbar from "./components/navbar/Navbar";
import { ThemeContext } from "./context";
import { initGA, trackPageView, trackSectionView } from "./utils/analytics";

function App() {
  useEffect(() => {
    initGA();
    trackPageView(window.location.pathname);

    // Section view observer (guarded for SSR/test environments)
    if (typeof window !== "undefined" && "IntersectionObserver" in window) {
      const sectionIds = ["home", "about", "projects", "contact"];
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
              trackSectionView(entry.target.id);
            }
          });
        },
        { threshold: [0.3] }
      );

      sectionIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });

      return () => observer.disconnect();
    }
  }, []);

  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className={`app ${darkMode ? "dark" : ""}`}>
      <Navbar />
      <div id="home">
        <Intro darkMode={darkMode} />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="projects">
        <ProductList />
      </div>
      <div id="contact">
        <Contact darkMode={darkMode} />
      </div>
      <ToastContainer />
    </div>
  );
}

export default App;
